import type { NavigateFunction } from 'react-router';

import { LOCAL_DOMAIN } from '../common/constants/urls';

export function getStorageItem<T = unknown>(
  key: string,
  defaultValue: T | null = null,
) {
  try {
    return (
      (JSON.parse(localStorage.getItem(key) as string) as T) || defaultValue
    );
  } catch (error) {
    console.error(error);
    return defaultValue;
  }
}

export function setStorageItem(key: string, value: unknown) {
  localStorage.setItem(key, JSON.stringify(value));
}

/***
 *
 * @param location: React Dom Location
 * @param navigate: React Dom Navigate
 * @param key: the params to be removed from url
 *
 * Note: If your component is relying on query param states for updating
 * component state or hook effects, this may cause your component to re-render
 */
export function removeQueryParam(
  location: { search: string },
  navigate: NavigateFunction,
  key: string,
) {
  const queryParams = new URLSearchParams(location.search);
  queryParams.delete(key);
  navigate({ search: queryParams.toString() }, { replace: true });
}

export const openInNewTab = (url?: string | null) => {
  if (!url) return;
  const newTab = window.open(url, '_blank');
  if (!newTab) return;
  newTab.opener = null;
  newTab.focus();
};

export const getWildDomain = (host: string) => {
  if (host.includes(LOCAL_DOMAIN)) {
    return host;
  }

  return '.' + host.split('.').slice(-2).join('.');
};
